module.exports = __webpack_public_path__ + "static/media/empty_collection.eb425ea1.svg";